import { useEffect, useRef } from "react"

/**
 * Custom hook to track the previous value of a state or prop.
 * @param value - The current value to track.
 * @returns The previous value.
 */
export default function usePrev<T>(value: T): T | undefined {
  const ref = useRef<T | undefined>(undefined)

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}
